import { defineStyleConfig } from '@chakra-ui/react';

export const Button = defineStyleConfig({
  baseStyle: {
    borderRadius: '6px',
  },

  sizes: {
    md: {
      fontSize: '14px',
    },
    sm: {
      fontSize: '12px',
      height: '34px',
    },
  },

  variants: {
    default: {
      color: 'white.0',
      bg: 'button',
      _hover: { bg: 'ocean.200', _loading: { bg: 'button' } },
      _active: { bg: 'ocean.300' },
      _loading: { bg: 'button', color: 'white.0' },
    },
    switchNotSelected: {
      border: '1px solid',
      borderColor: 'gray.300',
      color: 'gray.300',
      _hover: { border: '2.5px solid' },
      _active: { border: '2px solid' },
    },
    outline: {
      border: '2px solid',
      borderColor: 'button',
      color: 'button',
      _hover: { border: '2.5px solid' },
      _active: { border: '2px solid' },
      _loading: { color: 'button' },
    },
    outlineGray: {
      border: '2px solid',
      borderColor: 'gray.300',
      color: 'gray.300',
      _hover: { borderColor: 'gray.300', bg: 'gray.700' },
      _active: { borderColor: 'button', bg: 'button', color: 'white' },
    },
    ghost: {
      bg: 'none',
      _hover: { bg: 'none' },
    },
    disable: {
      bg: 'gray.100',
      color: 'gray.100',
    },
    link: {
      color: 'linkBlue',
      fontWeight: 400,
      _active: { color: 'linkBlue' },
    },
  },

  defaultProps: {
    size: 'md',
    variant: 'default',
  },
});
